// extracted by mini-css-extract-plugin
export default {"linkShowcase":"linkShowcase_linkShowcase__um+QU","linkText":"linkShowcase_linkText__pv8sF"};